"use strict";

const commonRules = require('../rules/commonRules');
const GetLocationModel = require('../../info-localization/getLocationModel');

class MainController extends GetLocationModel {
  constructor() {
    super();
    this.userLang = navigator.language || navigator.userLanguage;
    this.waLang = localStorage.getItem('langName');
    this.cnIp = false;
    this.jaIp = false;
    this.enSelect = localStorage.getItem("enSelect");
  }

  init() {
    this.request()
      .then(res => res.json()
        .then(data => {
          if (!data.countryCode) {
            throw new Error("Undefined Country");
          }
          window.countryCode = data.countryCode;
          this.cnIp = data.countryCode === 'CN';
          this.jaIp = data.countryCode === 'JP';
        }))
      .catch(() => {
        window.countryCode = 'US';
      })
      .finally(() => {
        this.cnDetect = this.userLang.includes('zh') || this.cnIp;
        this.jaDetect = this.userLang.includes('ja') || this.jaIp;
        this.runStrictRedirects();
        this.runSimpleRedirects(commonRules);
      })
  }

  checkChanceRedirect() {
    if (!localStorage.getItem('cnFirstVisit')) {
      this.mainRedirect();
    }
  }
  
  runStrictRedirects() {
    if (this.waLang === 'zh' || this.cnDetect) {
      this.pageRedirect('/extension/pricing', '/extension/cn/pricing/', '/extension/pricing');
      this.pageRedirect('/extension/upgrade', '/cn/iframe/customizable/', '/iframe/customizable/');
      this.pageRedirect('/upgrade', '/cn/upgrade/', '/upgrade', '/extension/cn/upgrade');
    }

    if (this.waLang === 'ja' || this.jaDetect) {
      this.pageRedirect('/extension/pricing', '/extension/ja/pricing/', '/extension/pricing');
      this.pageRedirect('/extension/upgrade', '/ja/iframe/customizable/', '/iframe/customizable/');
      this.pageRedirect('/upgrade', '/ja/upgrade/', '/upgrade', '/extension/ja/upgrade');
    }

    if (this.waLang === 'en') {
      this.pageRedirect('/extension/cn/pricing', '/extension/pricing/', '/extension/pricing');
      this.pageRedirect('/extension/upgrade', '/iframe/customizable/', '/iframe/customizable/');
    }

    if (this.userLang.includes('zh') || this.cnDetect) {
      this.checkChanceRedirect();
      this.pageRedirect('/checkout', '/cn/checkout/', '/checkout');
    }

    if (this.jaDetect) {
      this.pageRedirect('/checkout', '/ja/checkout/', '/checkout');
    }

    if ((this.userLang.includes('zh') || this.cnDetect) && !this.enSelect) {
      this.pageRedirect('/pro-ext/pricing', '/cn/pricing/', '/pricing');
      this.pageRedirect('/pricing', '/cn/pricing/', '/pricing');
    }

    if (this.jaDetect && !this.enSelect) {
      this.pageRedirect('/pricing', '/ja/pricing/', '/pricing');
    }
    if (this.waLang !== 'zh' || this.waLang !== 'ja' || this.waLang === 'en') {
      this.pageRedirect('/extension/upgrade', '/iframe/customizable/', '/iframe/customizable/');
    }
  }
  mainRedirect() {
    if (window.location.pathname === "/") {
      window.location.replace(window.origin + '/cn');
      localStorage.setItem('cnFirstVisit', true);
    }
  }

  pageRedirect(path, redirectPath, referrer, exception) {
    const check = exception ? document.referrer.includes(exception) : !document.referrer.includes(referrer);
    if ((window.location.pathname === path || window.location.pathname === path + '/') && check) {
      window.location.pathname = redirectPath;
    }
  }

  runSimpleRedirects(pages) {
    pages.forEach((obj) => {
      if (window.location.href ===`${window.location.origin}${obj.path}`) {
        return window.location.replace(obj.to);
      }
    });
  }
}

module.exports = MainController;
